<template>
  <component :is="tag" autocomplete='off' type='text' class='jdatepicker'></component>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import persianDatePicker from 'persian-datepicker/dist/js/persian-datepicker'
import DefaultDatePickerOptions from '@/components/DefaultDatePickerOptions.js'
export default {
  props: {
    inline: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    tag () {
      if (this.inline) {
        return 'div'
      } else {
        return 'input'
      }
    },
    calendarOptions () {
      return DefaultDatePickerOptions(this.inline)
    }
  },
  mounted () {
    $('.jdatepicker').pDatepicker(this.calendarOptions)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DatePicker.vue